import img14a from '../../../assets/gallery/14b/14b-01-HOME-insolada.jpg';
import img14b from '../../../assets/gallery/14b/14b-02-insolada.jpg';
import img14c from '../../../assets/gallery/14b/14b-03-insolada.jpg';
import img14d from '../../../assets/gallery/14b/14b-04-insolada.jpg';
import img14e from '../../../assets/gallery/14b/14b-05-insolada.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "",
    pictureSrc: img14a,
    description: "2014",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "",
    pictureSrc: img14b,
    description: "2014",
    orientation: "h"
  },
  {
    id: 3,
    title: "",
    dimensions: "",
    pictureSrc: img14c,
    description: "2014",
    orientation: "v"
  },
  {
    id: 4,
    title: "",
    dimensions: "",
    pictureSrc: img14d,
    description: "2014",
    orientation: "v"
  },
  {
    id: 5,
    title: "",
    dimensions: "",
    pictureSrc: img14e,
    description: "2014",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];



// WEBPACK FOOTER //
// ./src/pages/gallery/14b/data14b.js